
import utils from '../utils'

const nearStarsData = [
  {
    name: "Alpha Centauri",
    descriptionSource: "https://en.wikipedia.org/wiki/Alpha_Centauri",
    descriptionImage: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c6/The_bright_star_Alpha_Centauri_and_its_surroundings.jpg/440px-The_bright_star_Alpha_Centauri_and_its_surroundings.jpg",
    description: "Alpha Centauri is the nearest star to the Solar System. It is actually three stars locked in orbit, called Alpha Centauri A, B, and C. Alpha Centauri C is a red dwarf, much dimmer than the other two. A and B make Alpha Centauri the brightest star in the Centaurus constellation.",
    dis: utils.dis(4.2421), // distance: 4.2421 light-years
    asc: utils.asc(14, 29, 43), // right ascension: 14h 29m 43.0s
    dec: utils.dec(62, 40, 46, true), // declination: −62° 40′ 46″
  },
  {
    name: "Barnard",
    descriptionSource: "https://en.wikipedia.org/wiki/Barnard%27s_Star",
    descriptionImage: "https://upload.wikimedia.org/wikipedia/commons/1/18/Barnardstar2006.jpg",
    description: "Barnard is a small red dwarf star in the constellation Ophiuchus. It is too dim to be seen with the naked eye.",
    dis: utils.dis(5.9630), // distance: 5.9630 light-years
    asc: utils.asc(17, 29, 43), // right ascension: 17h 57m 48.5s
    dec: utils.dec(4, 41, 36), // declination: +04° 41′ 36″
  },
  {
    name: "Luhman 16",
    descriptionSource: "https://en.wikipedia.org/wiki/Luhman_16",
    description: "Luhman 16 is not really a star at all, but a pair of orbiting brown dwarfs. These bodies are too small to be stars, but each one is still about thirty times the mass of Jupiter.",
    dis: utils.dis(6.59), // distance: 6.59 light-years
    asc: utils.asc(10, 49, 15.57), // right ascension: 10h 49m 15.57s
    dec: utils.dec(53, 19, 9), // declination: +53° 19′ 09″
  },
  {
    name: "Wolf 359",
    descriptionSource: "https://en.wikipedia.org/wiki/Wolf_359",
    description: "Wolf 359 is a red dwarf in the constellation Leo. It is invisible to the naked eye, being one of the faintest stars known along with one of the smallest.",
    dis: utils.dis(7.7825), // distance: 7.7825 light-years
    asc: utils.asc(10, 56, 29.2), // right ascension: 10h 56m 29.2s
    dec: utils.dec(7, 0, 53), // declination: +07° 00′ 53″
  },
  {
    name: "Lalande 21185",
    descriptionSource: "https://en.wikipedia.org/wiki/Lalande_21185",
    description: "Lalande 21185 is a red dwarf in the constellation Ursa Major. It is the brightest red dwarf in the northern hemisphere. However, one still needs at least binoculars or a small telescope to observe this star.",
    dis: utils.dis(8.2905), // distance: 8.2905 light-years
    asc: utils.asc(11, 3, 20.2), // right ascension: 11h 03m 20.2s
    dec: utils.dec(35, 58, 12), // declination: +35° 58′ 12″
  },
  {
    name: "Sirius",
    descriptionSource: "https://en.wikipedia.org/wiki/Sirius",
    descriptionImage: "https://upload.wikimedia.org/wikipedia/commons/f/f3/Sirius_A_and_B_Hubble_photo.jpg",
    description: "Sirius is the brightest star in our sky. It is a binary system consisting of Sirius A and Sirius B. Sirius A, which creates most of the light, is twice the mass of our sun. Sirius B, on the other hand, is a white dwarf, the faded core left after a supernova.",
    dis: utils.dis(8.5828), // distance: 8.5828 light-years
    asc: utils.asc(6, 45, 8.9), // right ascension: 06h 45m 08.9s
    dec: utils.dec(16, 42, 58, true), // declination: −16° 42′ 58″
  },
  {
    name: "Luyten 726-8",
    descriptionSource: "https://en.wikipedia.org/wiki/Luyten_726-8",
    description: "Star system Luyten 726-8 consists of two stars of very similar brightness. Both are flare stars, occasionally increasing in brightness for a few minutes. Luyten 726-8B is especially remarkable in this respect.",
    dis: utils.dis(8.7280), // distance: 8.7280 light-years
    asc: utils.asc(1, 39, 1.3), // right ascension: 01h 39m 01.3s
    dec: utils.dec(17, 57, 1, true), // declination: −17° 57′ 01″
  },
  {
    name: "Ross 154",
    descriptionSource: "https://en.wikipedia.org/wiki/Ross_154",
    description: "Ross 154 is a red dwarf in the constellation Sagittarius. Although it is the closest star to the sun in its constellation, it is completely invisible to the unaided eye.",
    dis: utils.dis(9.6813), // distance: 9.6813 light-years
    asc: utils.asc(18, 49, 49.4), // right ascension: 18h 49m 49.4s
    dec: utils.dec(23, 50, 10, true) // declination: −23° 50′ 10″
  },
  {
    name: "Ross 248",
    descriptionSource: "https://en.wikipedia.org/wiki/Ross_248",
    description: "Ross 248 is a red dwarf too dim to be seen without visual assistance. It slightly fluctuates in brightness, which is attributed to spots on its photosphere.",
    dis: utils.dis(10.322), // distance: 10.322 light-years
    asc: utils.asc(23, 41, 54.7), // right ascension: 23h 41m 54.7s
    dec: utils.dec(44, 10, 30) // declination: +44° 10′ 30″
  },
  {
    name: "Epsilon Eridani",
    descriptionSource: "https://en.wikipedia.org/wiki/Epsilon_Eridani",
    description: "Epsilon Eridani is a star residing in the constellation Eridanus. It is somewhat smaller than the sun, and is less than one billion years old. Being still young, its solar wind is thirty times stronger than that of the sun.",
    dis: utils.dis(10.522), // distance: 10.522 light-years
    asc: utils.asc(3, 32, 55.8), // right ascension: 03h 32m 55.8s
    dec: utils.dec(9, 27, 30, true) // declination: −09° 27′ 30″
  },
  {
    name: "Lacaille 9352",
    descriptionSource: "https://en.wikipedia.org/wiki/Lacaille_9352",
    description: "Lacaille 9352 is the closest star in the constellation Piscis Austrinus. However, it is still imperceptible to the naked eye.",
    dis: utils.dis(10.742), // distance: 10.742 light-years
    asc: utils.asc(23, 5, 52), // right ascension: 23h 05m 52.0s
    dec: utils.dec(35, 51, 11, true) // declination: −35° 51′ 11″
  },
  {
    name: "Ross 128",
    descriptionSource: "https://en.wikipedia.org/wiki/Ross_128",
    description: "Ross 128 is a faint red dwarf in the constellation Virgo. It harbors a planet called Ross 128 b, which was the second exoplanet discovered. The roughly Earth-sized planet lies in the habitable zone of the star, and is a prime candidate for life.",
    dis: utils.dis(10.919), // distance: 10.919 light-years
    asc: utils.asc(11, 47, 44.4), // right ascension: 11h 47m 44.4s
    dec: utils.dec(0, 48, 16) // declination: +00° 48′ 16″
  },
  {
    name: "Wise 1506 7027",
    descriptionSource: "https://en.wikipedia.org/wiki/WISE_1506%2B7027",
    description: "Wise 1506 7027 is a sub-stellar brown dwarf in the constellation Ursa Minor.",
    dis: utils.dis(11.089), // distance: 11.089 light-years
    asc: utils.asc(15, 6, 49.9), // right ascension: 15h 06m 49.9s
    dec: utils.dec(70, 27, 36) // declination: +70° 27′ 36″
  },
  {
    name: "Ez Aquarii",
    descriptionSource: "https://en.wikipedia.org/wiki/EZ_Aquarii",
    description: "Ez Aquarii is a system of three red dwarfs. Two orbit each other and the third orbits them. All three reside in the constellation Aquarius.",
    dis: utils.dis(11.266), // distance: 11.266 light-years
    asc: utils.asc(22, 38, 33.4), // right ascension: 22h 38m 33.4s
    dec: utils.dec(15, 17, 57, true) // declination: −15° 17′ 57″
  },
  {
    name: "Procyon",
    descriptionSource: "https://en.wikipedia.org/wiki/Procyon",
    description: "Procyon is the brightest star in the constellation Canis Minor and the eighth brightest in the sky. It consists of two white stars, one of which is a faint white dwarf.",
    dis: utils.dis(11.402), // distance: 11.402 light-years
    asc: utils.asc(7, 39, 18.1), // right ascension: 07h 39m 18.1s
    dec: utils.dec(5, 13, 30) // declination: +05° 13′ 30″
  },
  {
    name: "61 Cyngi",
    descriptionSource: "https://en.wikipedia.org/wiki/61_Cygni",
    description: "61 Cyngi is a pair of orange-colored dwarfs in the Cygnus constellation. In areas with little light polution, the system can be seen with the naked eye.",
    dis: utils.dis(11.403), // distance: 11.403 light-years
    asc: utils.asc(21, 6, 53.9), // right ascension: 21h 06m 53.9s
    dec: utils.dec(38, 44, 58) // declination: +38° 44′ 58″
  },
  {
    name: "Struve 2398",
    descriptionSource: "https://en.wikipedia.org/wiki/Struve_2398",
    description: "Struve 2398 is a binary dwarf star in the constellation Draco. It is invisible without viewing equipment.",
    dis: utils.dis(11.525), // distance: 11.525 light-years
    asc: utils.asc(18, 42, 46.7), // right ascension: 18h 42m 46.7s
    dec: utils.dec(59, 37, 49) // declination: +59° 37′ 49″
  },
  {
    name: "Groombridge 34",
    descriptionSource: "https://en.wikipedia.org/wiki/Groombridge_34",
    description: "Groombridge 34 is a binary system of red dwarf stars of the Andromeda constellation. It is moving away from the Solar System relatively fast at 11.6 km/s.",
    dis: utils.dis(11.624), // distance: 11.624 light-years
    asc: utils.asc(0, 18, 22.9), // right ascension: 0h 18m 22.9s
    dec: utils.dec(44, 1, 23) // declination: +44° 01′ 23″
  },
  {
    name: "Epsilon Indi",
    descriptionSource: "https://en.wikipedia.org/wiki/Epsilon_Indi",
    description: "Epsilon Indi is a triple star system in the constellation of Indus. It contains one orange dwarf and two brown dwarfs. The orange star harbors a gas giant, the closest known outside the Solar System, with 2.7 times the mass of Jupiter.",
    dis: utils.dis(11.824), // distance: 11.824 light-years
    asc: utils.asc(22, 3, 21.7), // right ascension: 22h 03m 21.7s
    dec: utils.dec(56, 47, 10) // declination: −56° 47′ 10″
  },
  {
    name: "Dx Cancri",
    descriptionSource: "https://en.wikipedia.org/wiki/DX_Cancri",
    description: "Dx Cancri is a faint red dwarf in the constellation Cancer. It is a flare star, meaning its brightness can increase fivefold for short times.",
    dis: utils.dis(11.826), // distance: 11.826 light-years
    asc: utils.asc(8, 29, 49.5), // right ascension: 08h 29m 49.5s
    dec: utils.dec(26, 46, 37) // declination: +26° 46′ 37″
  },
  {
    name: "Tau Ceti",
    descriptionSource: "https://en.wikipedia.org/wiki/Tau_Ceti",
    description: "Tau Ceti is a single star in the constellation Cetus with 78% of the sun's mass. There is evidence that five planets orbit the star, of which two are in the habitable zone. Because of this, Tau Ceti is a candidate for life. However, it is also orbited by a disk of debris, and the resulting higher frequency of impacts would be a barrier for such life.",
    dis: utils.dis(11.887), // distance: 11.887 light-years
    asc: utils.asc(1, 44, 4.1), // right ascension: 01h 44m 04.1s
    dec: utils.dec(15, 56, 15, true) // declination: −15° 56′ 15″
  },
  {
    name: "GJ 1061",
    descriptionSource: "https://en.wikipedia.org/wiki/Gliese_1061",
    description: "GJ 1061 is a red dwarf in the Horologium constellation. It is only 0.1% as luminous as the sun.",
    dis: utils.dis(11.991), // distance: 11.991 light-years
    asc: utils.asc(3, 35, 59.7), // right ascension: 03h 35m 59.7s
    dec: utils.dec(44, 30, 45, true) // declination: −44° 30′ 45″
  },
  {
    name: "Wise 0350-5658",
    descriptionSource: "https://en.wikipedia.org/wiki/WISE_0350%E2%88%925658",
    description: "Wise 0350-5658, a brown dwarf, is the closest system in the constellation Reticulum.",
    dis: utils.dis(12.068), // distance: 12.068 light-years
    asc: utils.asc(3, 50, .32), // right ascension: 03h 50m 00.32s
    dec: utils.dec(56, 58, 30.2, true) // declination: −56° 58′ 30.2″
  },
  {
    name: "YZ Ceti",
    descriptionSource: "https://en.wikipedia.org/wiki/YZ_Ceti",
    description: "YZ Ceti is a red dwarf in the Cetus constellation. It is unusually close to its nearest neighbor Tau Ceti at mere 1.6 light years away.",
    dis: utils.dis(12.132), // distance: 12.132 light-years
    asc: utils.asc(1, 12, 30.6), // right ascension: 01h 12m 30.6s
    dec: utils.dec(16, 59, 56, true) // declination: −16° 59′ 56″
  },
  {
    name: "Luyten's Star",
    descriptionSource: "https://en.wikipedia.org/wiki/Luyten%27s_Star",
    description: "Luyten's Star is a red dwarf in the Canis Minor constellation. Orbiting it are two planets. One of these, called GJ 273b, is a rocky planet larger than Earth. GJ 273b is within the habitable zone, so it could be home to extraterrestrial life.",
    dis: utils.dis(12.366), // distance: 12.366 light-years
    asc: utils.asc(7, 27, 24.5), // right ascension: 07h 27m 24.5s
    dec: utils.dec(5, 13, 33) // declination: +05° 13′ 33″
  },
  {
    name: "Teegarden's Star",
    descriptionSource: "https://en.wikipedia.org/wiki/Teegarden%27s_Star",
    description: "Teegarden's Star is an invisible red dwarf in the constellation of Aries. The star is moving across the sky at about 1.4E-3 degrees per year, which is extraordinarily fast.",
    dis: utils.dis(12.514), // distance: 12.514 light-years
    asc: utils.asc(2, 53, .9), // right ascension: 02h 53m 00.9s
    dec: utils.dec(16, 52, 53) // declination: +16° 52′ 53″
  },
  {
    name: "SCR 1845-6357",
    descriptionSource: "https://en.wikipedia.org/wiki/SCR_1845-6357",
    description: "SCR 1845-6357 is a binary system of the Pavo constellation. One star is a red dwarf. The other is a sub-stellar brown dwarf 40-50 times the mass of Jupiter. Being about 50 times fainter than its companion, the brown dwarf was discovered years later.",
    dis: utils.dis(12.571), // distance: 12.571 light-years
    asc: utils.asc(18, 45, 5.3), // right ascension: 18h 45m 05.3s
    dec: utils.dec(63, 57, 48, true) // declination: −63° 57′ 48″
  },
  {
    name: "Kapteyn's Star",
    descriptionSource: "https://en.wikipedia.org/wiki/Kapteyn%27s_Star",
    description: "Kapteyn's Star is a red subdwarf in the constellation Pictor. It harbors two planets. One of them, Kapteyn b, is potentially habitable. This would make the planet the oldest habitable planet known, with an age of about 11 billion years. Kapteyn's Star is visible through binoculars.",
    dis: utils.dis(12.777), // distance: 12.777 light-years
    asc: utils.asc(5, 11, 40.6), // right ascension: 05h 11m 40.6s
    dec: utils.dec(45, 1, 6, true) // declination: −45° 01′ 06″
  },
  {
    name: "Lacaille 8760",
    descriptionSource: "https://en.wikipedia.org/wiki/Lacaille_8760",
    description: "Lacaille 8760 is a red dwarf in the Microscopium constellation. The star is one of the brightest red dwarfs known, but is still only visible to the naked eye under exceptional viewing conditions.",
    dis: utils.dis(12.870), // distance: 12.870 light-years
    asc: utils.asc(21, 17, 15.3), // right ascension: 21h 17m 15.3s
    dec: utils.dec(38, 52, 3, true) // declination: −38° 52′ 03″
  },
  {
    name: "Wise 0535-7500",
    descriptionSource: "https://en.wikipedia.org/wiki/WISE_0535%E2%88%927500",
    description: "Wise 0535-7500 is a pair of bodies in the constellation Mensa. Both are too small for any fusion to occur within them, so they are essentially free-floating planets.",
    dis: utils.dis(13.0), // distance: 13.0 light-years
    asc: utils.asc(5, 35, 16.8), // right ascension: 05h 35m 16.8s
    dec: utils.dec(75, 0, 24.9, true) // declination: −75° 00′ 24.9″
  },
  {
    name: "Kruger 60",
    descriptionSource: "https://en.wikipedia.org/wiki/Kruger_60",
    description: "Kruger 60 is a pair of red dwarfs in the Cepheus constellation. The average distance between the two is about the same as the distance between the sun and Saturn. the stars complete one orbit every 44.6 years.",
    dis: utils.dis(13.149), // distance: 13.149 light-years
    asc: utils.asc(22, 27, 59.5), // right ascension: 22h 27m 59.5s
    dec: utils.dec(57, 41, 45) // declination: +57° 41′ 45″
  },
  {
    name: "DEN 1048 3956",
    descriptionSource: "https://en.wikipedia.org/wiki/DEN_1048%E2%88%923956",
    description: "DEN 1048-3956 is a brown dwarf in the Antlia constellation. It was first detected when it emitted a powerful radio flare.",
    dis: utils.dis(13.167), // distance: 13.167 light-years
    asc: utils.asc(10, 48, 14.7), // right ascension: 10h 48m 14.7s
    dec: utils.dec(39, 56, 6, true) // declination: −39° 56′ 06″
  },
  {
    name: "UGPS 0722-05",
    descriptionSource: "https://en.wikipedia.org/wiki/UGPS_J0722-0540",
    description: "UGPS 0722-05 is a brown dwarf in the constellation Monoceros about Jupiter's volume.",
    dis: utils.dis(13.259), // distance: 13.259 light-years
    asc: utils.asc(7, 22, 27.3), // right ascension: 07h 22m 27.3s
    dec: utils.dec(5, 40, 30, true) // declination: –05° 40′ 30″
  },
  {
    name: "Ross 614",
    descriptionSource: "https://en.wikipedia.org/wiki/Ross_614",
    description: "Ross 614 is a binary red dwarf system in the constellation Monoceros. The system is too dim to be seen without the aid of a telescope.",
    dis: utils.dis(13.349), // distance: 13.349 light-years
    asc: utils.asc(6, 29, 23.4), // right ascension: 06h 29m 23.4s
    dec: utils.dec(2, 48, 50, true) // declination: −02° 48′ 50″
  },
  {
    name: "Wolf 1061",
    descriptionSource: "https://en.wikipedia.org/wiki/Wolf_1061",
    description: "Wolf 1061 is a red dwarf of the constellation Ophiuchus. It harbors three planets, two of which might be home to life.",
    dis: utils.dis(13.820), // distance: 13.820 light-years
    asc: utils.asc(16, 30, 18.1), // right ascension: 16h 30m 18.1s
    dec: utils.dec(12, 39, 45, true) // declination: −12° 39′ 45″
  },
  {
    name: "Van Maanen's Star",
    descriptionSource: "https://en.wikipedia.org/wiki/Van_Maanen_2",
    description: "van Maanen's Star resides in the constellation Pisces. It is a dense white dwarf, a remnant left over by a much larger star. It is the closest known white dwarf lacking a companion star.",
    dis: utils.dis(14.066), // distance: 14.066 light-years
    asc: utils.asc(0, 49, 9.9), // right ascension: 00h 49m 09.9s
    dec: utils.dec(5, 23, 19) // declination: +05° 23′ 19″
  },
  {
    name: "Gliese 1",
    descriptionSource: "https://en.wikipedia.org/wiki/Gliese_1",
    description: "Gliese 1 is a red dwarf in the constellation of Sculptor. Its faintness makes it impossible to see with the unaided eye.",
    dis: utils.dis(14.231), // distance: 14.231 light-years
    asc: utils.asc(0, 5, 24.4), // right ascension: 00h 05m 24.4s
    dec: utils.dec(37, 21, 27, true) // declination: −37° 21′ 27″
  },
  {
    name: "Wolf 424",
    descriptionSource: "https://en.wikipedia.org/wiki/Wolf_424",
    description: "Wolf 424 is a binary red dwarf system in the Virgo constellation. The stars are two of the dimmest known nearby stars in the sky.",
    dis: utils.dis(14.312), // distance: 14.312 light-years
    asc: utils.asc(12, 33, 17.2), // right ascension: 12h 33m 17.2s
    dec: utils.dec(9, 1, 15) // declination: +09° 01′ 15″
  },
  {
    name: "2MASS J154043",
    descriptionSource: "https://en.wikipedia.org/wiki/2MASS_J154043.42-510135.7",
    description: "2MASS J154043 is a dim red dwarf in the Norma constellation.",
    dis: utils.dis(14.4), // distance: 14.4 light-years
    asc: utils.asc(15, 40, 43.42), // right ascension: 15h 40m 43.42s
    dec: utils.dec(51, 1, 35.7, true) // declination: −51° 01′ 35.7″
  },
  {
    name: "L 1159-16",
    descriptionSource: "https://en.wikipedia.org/wiki/L_1159-16",
    description: "L 1159-16 is a red dwarf in the Aries constellation. It is too faint to be visible without a telescope.",
    dis: utils.dis(14.509), // distance: 14.509 light-years
    asc: utils.asc(2, 0, 13.2), // right ascension: 02h 00m 13.2s
    dec: utils.dec(13, 3, 8) // declination: +13° 03′ 08″
  },
  {
    name: "Gliese 687",
    descriptionSource: "https://en.wikipedia.org/wiki/Gliese_687",
    description: "Gliese 687 is a red dwarf in the constellation of Draco. A moderately sized telescope is required to spot it. Gliese 687 is orbited by a planet about the mass of Neptune.",
    dis: utils.dis(14.793), // distance: 14.793 light-years
    asc: utils.asc(17, 36, 25.9), // right ascension: 17h 36m 25.9s
    dec: utils.dec(68, 20, 21) // declination: +68° 20′ 21″
  },
  {
    name: "LHS 292",
    descriptionSource: "https://en.wikipedia.org/wiki/LHS_292",
    description: "LHS 292 resides in the Sextans constellation. Being a faint red dwarf, it can only be seen through a large telescope.",
    dis: utils.dis(14.805), // distance: 14.805 light-years
    asc: utils.asc(10, 48, 12.6), // right ascension: 10h 48m 12.6s
    dec: utils.dec(11, 20, 14, true) // declination: −11° 20′ 14″
  },
  {
    name: "Gliese 674",
    descriptionSource: "https://en.wikipedia.org/wiki/Gliese_674",
    description: "Gliese 674 is a red dwarf in the constellation Ara. A planet about twelve times the mass of Earth orbits the star.",
    dis: utils.dis(14.809), // distance: 14.809 light-years
    asc: utils.asc(17, 28, 39.9), // right ascension: 17h 28m 39.9s
    dec: utils.dec(46, 53, 43, true) // declination: −46° 53′ 43″
  },
  {
    name: "GJ 1245",
    descriptionSource: "https://en.wikipedia.org/wiki/GJ_1245",
    description: "GJ 1245 is a system in the Cygnus constellation. It is made of three red dwarfs. Two orbit each other and this binary system orbits another red dwarf.",
    dis: utils.dis(14.812), // distance: 14.812 light-years
    asc: utils.asc(19, 53, 54.2), // right ascension: 19h 53m 54.2s
    dec: utils.dec(44, 24, 55) // declination: +44° 24′ 55″
  },
  {
    name: "LP 145-141",
    descriptionSource: "https://en.wikipedia.org/wiki/LP_145-141",
    description: "LP 145-141 is a white dwarf in the Musca constellation. It is thought to follow a highly eccentric orbit around the galaxy.",
    dis: utils.dis(15.060), // distance: 15.060 light-years
    asc: utils.asc(11, 45, 42.9), // right ascension: 11h 45m 42.9s
    dec: utils.dec(64, 50, 29, true) // declination: −64° 50′ 29″
  },
  {
    name: "GJ 1002",
    descriptionSource: "https://en.wikipedia.org/wiki/Gliese_1002",
    description: "GJ 1002 is a red dwarf in the Cetus constellation. Unlike many red dwarfs, it does not emit any flares.",
    dis: utils.dis(15.313), // distance: 15.313 light-years
    asc: utils.asc(0, 6, 43.8), // right ascension: 00h 06m 43.8s
    dec: utils.dec(7, 32, 22, true) // declination: −07° 32′ 22″
  },
  {
    name: "Gliese 876",
    descriptionSource: "https://en.wikipedia.org/wiki/Gliese_876#Planetary_system",
    // TODO: Talk about inclination of planets?
    description: "Gliese 876 is a red dwarf in the Aquarius constellation. It is orbited by four planets. The middle two of these are in the habitable zone of the star, although they are both gas giants. Three of the planets are also in a 1:2:4 resonance. They are the only known example of this phenomenon other than Jupiter's inner three Galilean moons.",
    dis: utils.dis(15.342), // distance: 15.342 light-years
    asc: utils.asc(22, 53, 16.7), // right ascension: 22h 53m 16.7s
    dec: utils.dec(14, 15, 49, true) // declination: −14° 15′ 49″
  },
  {
    name: "LHS 288",
    descriptionSource: "https://en.wikipedia.org/wiki/LHS_288",
    description: "LHS 288 is normally invisible red dwarf in the constellation Carina. It might have a gaseous planet orbiting it, but this is not confirmed.",
    dis: utils.dis(15.610), // distance: 15.610 light-years
    asc: utils.asc(10, 44, 21.2), // right ascension: 10h 44m 21.2s
    dec: utils.dec(61, 12, 36, true) // declination: −61° 12′ 36″
  },
  {
    name: "Gliese 412",
    descriptionSource: "https://en.wikipedia.org/wiki/Gliese_412",
    description: "Gliese 412 is a dim red dwarf duo thought to form a binary system. The two are part of the constellation Ursa Major.",
    dis: utils.dis(15.832), // distance: 15.832 light-years
    asc: utils.asc(11, 5, 28.6), // right ascension: 11h 05m 28.6s
    dec: utils.dec(43, 31, 36) // declination: +43° 31′ 36″
  },
  {
    name: "Groombridge 1618",
    descriptionSource: "https://en.wikipedia.org/wiki/Groombridge_1618",
    description: "Groombridge 1618 is a star in the constellation Ursa Major. It is theorized that it has a planetary companion at least four times the mass of Jupiter. If this companion exists, then it is in the habitable zone.",
    dis: utils.dis(15.848), // distance: 15.848 light-years
    asc: utils.asc(10, 11, 22.1), // right ascension: 10h 11m 22.1s
    dec: utils.dec(49, 27, 15) // declination: +49° 27′ 15″
  },
  {
    name: "AD Leonis",
    descriptionSource: "https://en.wikipedia.org/wiki/AD_Leonis",
    description: "AD Leonis is a red dwarf in the constellation Leo. While red dwarfs can be much older than the sun, AD Leonis is thought to be relatively young, at only 25–300 million years of age.",
    dis: utils.dis(15.942), // distance: 15.942 light-years
    asc: utils.asc(10, 19, 36.4), // right ascension: 10h 19m 36.4s
    dec: utils.dec(19, 52, 10) // declination: +19° 52′ 10″
  },
  {
    name: "Denis J081730",
    descriptionSource: "https://en.wikipedia.org/wiki/DENIS_J081730.0-615520",
    description: "Denis J081730 is a sub-stellar brown dwarf in the Carina constellation. It has a mass fifteen times that of Jupiter.",
    dis: utils.dis(16.067), // distance: 16.067 light-years
    asc: utils.asc(8, 17, 30.1), // right ascension: 08h 17m 30.1s
    dec: utils.dec(61, 55, 16, true) // declination: −61° 55′ 16″
  },
  {
    name: "Gliese 832",
    descriptionSource: "https://en.wikipedia.org/wiki/Gliese_832",
    description: "Gliese 832 is a normally invisible red dwarf in the Grus constellation. It is home to two planets. One of these is a gas giant, while the other is rocky and potentially habitable.",
    dis: utils.dis(16.085), // distance: 16.085 light-years
    asc: utils.asc(21, 33, 34), // right ascension: 21h 33m 34.0s
    dec: utils.dec(49, 0, 32, true) // declination: −49° 00′ 32″
  },
  {
    name: "DEN 0255-4700",
    descriptionSource: "https://en.wikipedia.org/wiki/DEN_0255-4700",
    description: "DEN 0255-4700 is a brown dwarf in the constellation of Eridanus. It is the faintest of any known brown dwarf.",
    dis: utils.dis(16.197), // distance: 16.197 light-years
    asc: utils.asc(2, 55, 3.7), // right ascension: 02h 55m 03.7s
    dec: utils.dec(47, 0, 52, true) // declination: −47° 00′ 52″
  },
  {
    name: "GJ 1005",
    descriptionSource: "https://en.wikipedia.org/wiki/GJ_1005",
    description: "GJ 1005 is a binary system of two faint red dwarfs in the Cetus constellation.",
    dis: utils.dis(16.265), // distance: 16.265 light-years
    asc: utils.asc(0, 15, 28.11), // right ascension: 00h 15m 28.11s
    dec: utils.dec(16, 8, 1.6, true) // declination: −16° 08′ 01.6″
  },
];

export default nearStarsData;